import PendingIcon from "@/assets/colorable/pending.svg?react";
import TickIcon from "@/assets/colorable/tick_medium.svg?react";
import type {TSubmissionStatus} from "@/hooks/useContentApproval";
import clsxm from "@/lib/clsxm";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const ContentApprovalStatusChip: FC<{className?: string; label?: string; status: TSubmissionStatus}> = ({
  className,
  label,
  status,
}) => {
  const {t} = useTranslation(["content_approval", "influencer_list"]);

  let chipLabel: string;
  switch (status) {
    case "PENDING":
      chipLabel = t("review");
      break;
    case "REVISION_REQUESTED":
      chipLabel = t("revision_pending");
      break;
    case "APPROVED":
      chipLabel = t("influencer_list:content_approved");
      break;
    case "PUBLISHED":
      chipLabel = t("published");
      break;
    case "REJECTED":
      chipLabel = t("rejected");
      break;
    default:
      chipLabel = t("review");
  }

  return (
    <div
      className={clsxm(
        "bg-primary-powder border-primary-sky flex min-h-5 w-fit items-center gap-1 rounded-full border px-2",
        status === "REJECTED" && "border-danger-raspberry bg-danger-light-red",
        (status === "APPROVED" || status === "PUBLISHED") && "border-success-dark-green bg-success-light-green",
        className,
      )}>
      {status !== "REJECTED" &&
        (status === "PENDING" || status === "REVISION_REQUESTED" ? (
          <PendingIcon className="text-neutral-black size-2.5 shrink-0" />
        ) : (
          <TickIcon className="text-success-dark-green h-1.5 w-2 shrink-0" />
        ))}
      <span
        className={clsxm(
          "text-neutral-black text-2xs flex items-center text-center leading-3.5 font-semibold uppercase",
          (status === "APPROVED" || status === "PUBLISHED") && "text-success-dark-green",
        )}>
        {label ?? chipLabel}
      </span>
    </div>
  );
};

export default ContentApprovalStatusChip;
